import Bus from '../../bus'
import { logger } from '../../utils'
import { ACCEPT_ODDS_CHANGES_TYPES, THEME_CONTRAST } from '../../constants'

import storage from '../storage'

const DEFAULT_SETTINGS = {
  lang: 'ENG',
  theme: THEME_CONTRAST.LIGHT,
  multiline: false,

  quickBet: false,
  mybetsBetTypesDisplay: 'All',
  acceptOddsChanges: ACCEPT_ODDS_CHANGES_TYPES.UP,
  testBetslipSetting: 0,

  betslipSize: false,

  oddsFormat: 'decimal',
  allowSounds: false,
  displayNotifications: true,
  lightIndications: true,
  isBalanceHidden: false,

  isCordova: false,
  allowTracking: true,
  trackingId: null,
  gtm: null,
  googleAPIKey: null,
  affiliateId: null,
  countryWhitelist: [],
  clientBlocked: false,

  debugMode: false
}

const SETTINGS_PERSISTENCE_KEYS = [
  'lang',
  'betslipSize',
  'multiline',
  'acceptOddsChanges',
  'oddsFormat',
  'displayNotifications',
  'lightIndications',
  'isBalanceHidden',
  'quickBet',
  'theme',
  'debugMode'
]

const SETTINGS_MANAGER_STORAGE_KEY = 's' // settings prefix

class SettingsManager {
  constructor () {
    this.settings = DEFAULT_SETTINGS
  }

  async resolveSettings () {
    return await storage.getDataByStorageKeys(
      SETTINGS_PERSISTENCE_KEYS,
      SETTINGS_MANAGER_STORAGE_KEY
    ).then((storedSettings) => {
      console.log('resolveSettings', storedSettings)
      this.settings = {
        ...this.settings,
        ...storedSettings
      }
      Bus.send({
        event: Bus.events.settings.update,
        data: this.settings
      })
    })
  }

  configure (options) {
    this.settings = {
      ...this.settings,
      ...options
    }

    logger.debug('[settings]', '🛠️', 'configuring the application', this.settings)
  }

  getSettings () {
    return this.settings
  }

  updateSettings (options) {
    logger.debug('[settings]', '🛠️', 'updating settings', options)

    this.settings = {
      ...this.settings,
      ...options
    }

    storage.storeDataByStorageKeys(
      options,
      SETTINGS_PERSISTENCE_KEYS,
      SETTINGS_MANAGER_STORAGE_KEY
    )

    Bus.send({
      event: Bus.events.settings.update,
      data: this.settings
    })
  }
}

const $settings = new SettingsManager()

if (process.env.NODE_ENV === 'development') {
  window.$settings = $settings
}

export default $settings
